import React, { useEffect, useState } from "react";
import "./WorkflowTable.scss";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { IHistoryRun } from "./models/WorkflowTable.model";
import { SiTicktick } from "react-icons/si";
import { FaPlay } from "react-icons/fa";
import { MdErrorOutline } from "react-icons/md";
import { RiProgress4Line } from "react-icons/ri";
import { Slider } from "primereact/slider";
import { IAgentRuntime } from "../../../../../../models/AgentRuntime.model";
import { FaArrowLeftLong } from "react-icons/fa6";

interface WorkflowTableProps {
  agentRun: IAgentRuntime;
  handleStartWorkflow: any;
  handleRunClick: any;
  handleBack: any;
}

export default function WorkflowTable({
  agentRun,
  handleStartWorkflow,
  handleRunClick,
  handleBack,
}: WorkflowTableProps) {
  const [expandedRows, setExpandedRows] = useState<any>(null);

  const statusBodyTemplate = (rowData: IHistoryRun) => {
    switch (rowData["status"]) {
      case "success":
        return (
          <span className="success">
            <SiTicktick />
          </span>
        );
      case "failed":
        return (
          <span className="failed">
            <MdErrorOutline />
          </span>
        );
      case "inProgress":
        return (
          <span className="in-progress">
            <RiProgress4Line />
          </span>
        );
      default:
        break;
    }
  };

  const scoreBodyTemplate = (rowData: IHistoryRun) => {
    return (
      <div className="score">
        <Slider value={rowData["score"]} />
        <span>{rowData["score"]}%</span>
      </div>
    );
  };

  const dateBodyTemplate = (rowData: IHistoryRun) => {
    return <>{new Date(rowData["runDateTime"]).toLocaleString()}</>;
  };

  const hrefBodyTemplate = (rowData: IHistoryRun) => {
    return (
      <p className="href-link" onClick={() => handleRunClick(rowData.runId)}>
        {rowData["runId"]}
      </p>
    );
  };

  const rowExpansionTemplate = (data: IAgentRuntime) => (
    <div className="p-3">
      <DataTable value={data.historyRuns} stripedRows>
        <Column
          field="status"
          header=""
          body={statusBodyTemplate}
          style={{ width: "40px" }}
        ></Column>
        <Column field="runId" body={hrefBodyTemplate} header="Run ID"></Column>
        <Column
          field="runDateTime"
          body={dateBodyTemplate}
          header="RunDate Time"
        ></Column>
        <Column field="tokensUsed" header="Tokens Used"></Column>
        <Column field="score" body={scoreBodyTemplate} header="Score"></Column>
      </DataTable>
    </div>
  );

  const actionBodyTemplate = (rowData: IHistoryRun) => (
    <Button
      className="p-button-success play-icon"
      onClick={() => handleStartWorkflow(rowData.configId)}
      rounded
    >
      <FaPlay />
    </Button>
  );

  const returnWorkflowConfigGrouping = () => {
    if (agentRun?.historyRuns) {
      const configRows = agentRun?.historyRuns.reduce((list: any[], item) => {
        if (list.length > 0) {
          if (list.some((listItem) => listItem.configId === item.configId)) {
            list = list.map((listItem) => {
              if (listItem.configId === item.configId) {
                listItem.historyRuns.push(item);
              }
              return listItem;
            });
          } else {
            list.push({
              configId: item.configId,
              historyRuns: [item],
            });
          }
        } else {
          list.push({
            configId: item.configId,
            historyRuns: [item],
          });
        }
        return list;
      }, []);
      return configRows;
    } else {
      return [];
    }
  };

  useEffect(() => {
    const expandedRow: any = {};
    if (agentRun?.historyRuns) {
      agentRun?.historyRuns.forEach((item, i) => {
        expandedRow[i] = true;
      });
      setExpandedRows(expandedRow);
    }
  }, [agentRun?.historyRuns]);

  return (
    <div className="workflow-table">
      <div className="header-title">
        <div className="title">
          <Button rounded className="default" onClick={() => handleBack()}>
            <FaArrowLeftLong />
          </Button>
          <h2>{agentRun.label}</h2>
        </div>
        <Button
          label="New Config Run"
          className="primary"
          onClick={() => handleStartWorkflow("")}
        />
      </div>
      <div className="workflow-runs">
        <DataTable
          value={returnWorkflowConfigGrouping().map((item, i) =>
            Object({ ...item, datakey: i })
          )}
          expandedRows={expandedRows}
          onRowToggle={(e) => setExpandedRows(e.data)}
          rowExpansionTemplate={rowExpansionTemplate}
          tableStyle={{ minWidth: "50rem" }}
          dataKey="datakey"
        >
          <Column expander style={{ width: "3rem" }} />
          <Column field="configId" header="Config ID"></Column>
          <Column
            header=""
            body={actionBodyTemplate}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              paddingRight: "2rem",
            }}
          />
        </DataTable>
      </div>
    </div>
  );
}
